module.exports = {
	"_format": "hh-sol-artifact-1",
	"contractName": "MiniMeToken",
	"sourceName": "contracts/levels/MayTheForceBeWithYou.sol",
	"abi": [
		{
			"inputs": [
				{
					"internalType": "string",
					"name": "_tokenName",
					"type": "string"
				},
				{
					"internalType": "uint8",
					"name": "_decimalUnits",
					"type": "uint8"
				},
				{
					"internalType": "string",
					"name": "_tokenSymbol",
					"type": "string"
				}
			],
			"stateMutability": "nonpayable",
			"type": "constructor"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "_owner",
					"type": "address"
				},
				{
					"indexed": true,
					"internalType": "address",
					"name": "_spender",
					"type": "address"
				},
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "_amount",
					"type": "uint256"
				}
			],
			"name": "Approval",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "previousOwner",
					"type": "address"
				},
				{
					"indexed": true,
					"internalType": "address",
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "OwnershipTransferred",
			"type": "event"
		},
		{
			"anonymous": false,
			"inputs": [
				{
					"indexed": true,
					"internalType": "address",
					"name": "_from",
					"type": "address"
				},
				{
					"indexed": true,
					"internalType": "address",
					"name": "_to",
					"type": "address"
				},
				{
					"indexed": false,
					"internalType": "uint256",
					"name": "_amount",
					"type": "uint256"
				}
			],
			"name": "Transfer",
			"type": "event"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "_owner",
					"type": "address"
				},
				{
					"internalType": "address",
					"name": "_spender",
					"type": "address"
				}
			],
			"name": "allowance",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "remaining",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "_spender",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "_amount",
					"type": "uint256"
				}
			],
			"name": "approve",
			"outputs": [
				{
					"internalType": "bool",
					"name": "success",
					"type": "bool"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "_owner",
					"type": "address"
				}
			],
			"name": "balanceOf",
			"outputs": [
				{
					"internalType": "uint256",
					"name": "balance",
					"type": "uint256"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "decimals",
			"outputs": [
				{
					"internalType": "uint8",
					"name": "",
					"type": "uint8"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "_owner",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "_amount",
					"type": "uint256"
				}
			],
			"name": "mint",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "name",
			"outputs": [
				{
					"internalType": "string",
					"name": "",
					"type": "string"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"internalType": "address",
					"name": "",
					"type": "address"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "renounceOwnership",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [],
			"name": "symbol",
			"outputs": [
				{
					"internalType": "string",
					"name": "",
					"type": "string"
				}
			],
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "_to",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "_amount",
					"type": "uint256"
				}
			],
			"name": "transfer",
			"outputs": [
				{
					"internalType": "bool",
					"name": "success",
					"type": "bool"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "_from",
					"type": "address"
				},
				{
					"internalType": "address",
					"name": "_to",
					"type": "address"
				},
				{
					"internalType": "uint256",
					"name": "_amount",
					"type": "uint256"
				}
			],
			"name": "transferFrom",
			"outputs": [
				{
					"internalType": "bool",
					"name": "success",
					"type": "bool"
				}
			],
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"inputs": [
				{
					"internalType": "address",
					"name": "newOwner",
					"type": "address"
				}
			],
			"name": "transferOwnership",
			"outputs": [],
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "0x608060405234801561001057600080fd5b50600436106100d45760003560e01c8063715018a611610081578063a9059cbb1161005b578063a9059cbb14610284578063dd62ed3e146102b0578063f2fde38b146102de576100d4565b8063715018a6146102505780638da5cb5b1461025857806395d89b411461027c576100d4565b8063313ce567116100b2578063313ce567146101cc57806340c10f19146101ea57806370a0823114610218576100d4565b806306fdde03146100d9578063095ea7b31461015657806323b872dd14610196575b600080fd5b6100e1610304565b6040805160208082528351818301528351919283929083019185019080838360005b8381101561011b578181015183820152602001610103565b50505050905090810190601f1680156101485780820380516001836020036101000a031916815260200191505b509250505060405180910390f35b6101826004803603604081101561016c57600080fd5b506001600160a01b038135169060200135610391565b604080519115158252519081900360200190f35b610182600480360360608110156101ac57600080fd5b506001600160a01b03813581169160208101359091169060400135610431565b6101d46104a3565b6040805160ff9092168252519081900360200190f35b6102166004803603604081101561020057600080fd5b506001600160a01b0381351690602001356104ac565b005b61023e6004803603602081101561022e57600080fd5b50356001600160a01b031661053d565b60408051918252519081900360200190f35b610216610558565b610260610619565b604080516001600160a01b039092168252519081900360200190f35b6100e1610628565b6101826004803603604081101561029a57600080fd5b506001600160a01b038135169060200135610683565b61023e600480360360408110156102c657600080fd5b506001600160a01b0381358116916020013516610690565b610216600480360360208110156102f457600080fd5b50356001600160a01b03166106bb565b60018054604080516020600284861615610100026000190190941693909304601f810184900484028201840190925281815292918301828280156103895780601f1061035e57610100808354040283529160200191610389565b820191906000526020600020905b81548152906001019060200180831161036c57829003601f168201915b505050505081565b60008115806103c157503360009081526005602090815260408083206001600160a01b0387168452909152902054155b6103ca57600080fd5b3360008181526005602090815260408083206001600160a01b03881680855290835292819020869055805186815290519293927f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925929181900390910190a350600192915050565b6001600160a01b03831660009081526005602090815260408083203384529091528120548211156104645750600061049c565b6001600160a01b03841660009081526005602090815260408083203384529091529020805483900390556104998484846107d2565b90505b9392505050565b60025460ff1681565b6104b46108cc565b6000546001600160a01b03908116911614610516576040805162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604482015290519081900360640190fd5b6001600160a01b039091166000908152600460205260409020819055600680549091019055565b6001600160a01b031660009081526004602052604090205490565b6105606108cc565b6000546001600160a01b039081169116146105c2576040805162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604482015290519081900360640190fd5b600080546040516001600160a01b03909116907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e0908390a36000805473ffffffffffffffffffffffffffffffffffffffff19169055565b6000546001600160a01b031690565b6003805460408051602060026001851615610100026000190190941693909304601f810184900484028201840190925281815292918301828280156103895780601f1061035e57610100808354040283529160200191610389565b600061049c3384846107d2565b6001600160a01b03918216600090815260056020908152604080832093909416825291909152205490565b6106c36108cc565b6000546001600160a01b03908116911614610725576040805162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e6572604482015290519081900360640190fd5b6001600160a01b03811661076a5760405162461bcd60e51b81526004018080602001828103825260268152602001806108d16026913960400191505060405180910390fd5b600080546040516001600160a01b03808516939216917f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e091a36000805473ffffffffffffffffffffffffffffffffffffffff19166001600160a01b0392909216919091179055565b6000816107e15750600161049c565b6001600160a01b0383161580159061080257506001600160a01b0383163014155b61080b57600080fd5b6001600160a01b0384166000908152600460205260409020548211156108335750600061049c565b6001600160a01b038085166000908152600460205260408082208054869003905591851681522054808301101561086957600080fd5b6001600160a01b038084166000818152600460209081526040918290208054870190558151868152915192938816927fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef9281900390910190a35060019392505050565b339056fe4f776e61626c653a206e6577206f776e657220697320746865207a65726f2061646472657373a2646970667358221220286dd0e2c99a3a3e5b90a0ee9c29e05420f03689840ae86dda39f704308ebb2e64736f6c634300060c0033",
	"linkReferences": {},
	"deployedLinkReferences": {}
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/levels/MayTheForceBeWithYou.sol/MiniMeToken.json
// module id = 1585
// module chunks = 0